import { useState } from "react";

import { READ_NEWS } from "shared/constants/strings";

const getReadNewsIds = (): number[] => {
    try {
        const stored = JSON.parse(localStorage.getItem(READ_NEWS) ?? "[]");

        return Array.isArray(stored) ? stored : [];
    } catch {
        return [];
    }
};

const useReadNews = () => {
    const [readNewsIds, setReadNewsIds] = useState<number[]>(getReadNewsIds);

    const markAsRead = (id: number) => {
        if (readNewsIds.includes(id)) return;

        const updatedIds = [...readNewsIds, id];
        setReadNewsIds(updatedIds);
        localStorage.setItem(READ_NEWS, JSON.stringify(updatedIds));
    };

    const isNewsNew = (id: number, createdAt: string) => {
        const ONE_WEEK_IN_DAYS = 7;
        const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

        const daysSinceCreated =
            (Date.now() - new Date(createdAt).getTime()) / ONE_DAY_IN_MS;

        const isRecent = daysSinceCreated < ONE_WEEK_IN_DAYS;

        return isRecent && !readNewsIds.includes(id);
    };

    return { markAsRead, isNewsNew };
};

export { useReadNews };
